module.exports = __webpack_public_path__ + "assets/img/figure1.dd8cd898.svg";